/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { DataTable, DataTableColumn as TD, DataTableHeader as TH, DataTableRow as TR, NavigationDrawer, NormalButton, ToolbarDateNavigation } from 'ui-library/dist/external/components'
import { BaseLayout, ListViewLayout, LocalAreaLayout } from 'ui-library/dist/external/layouts'
import Dropdown from '../../../atoms/input/Dropdown'
import LocalDate from '../../../../domain/type/Date'
import Date from '../../../unit/Date'
import Money from '../../../unit/Money'
import MonthlyReportAction from '../../../../action/monthly_report'

export default props => {
  const date = props.match.params.date
  const target_date = date ? LocalDate.parse(date) : LocalDate.today().beginningOfMonth()
  const toolbar = { label: `売上レポート`, items: props.accountMenu }

  const paginations = {
    current: {
      label: '今月',
      onClick: e => {
        const current = LocalDate.today()
          .beginningOfMonth()
          .toISODate()
        MonthlyReportAction.onMonthlySalesMonthChanged(current, props.search.search_hotel_id)
      }
    },
    prev: {
      onClick: e => {
        const lastMonth = target_date.lastMonth().toISODate()
        MonthlyReportAction.onMonthlySalesMonthChanged(lastMonth, props.search.search_hotel_id)
      }
    },
    next: {
      onClick: e => {
        const nextMonth = target_date.nextMonth().toISODate()
        MonthlyReportAction.onMonthlySalesMonthChanged(nextMonth, props.search.search_hotel_id)
      }
    }
  }
  const meta = {
    component: ToolbarDateNavigation,
    data: { label: target_date.format('yyyy年MM月'), paginations: paginations }
  }

  return (
    <React.Fragment>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} meta={meta} />

      <BaseLayout>
        <LocalAreaLayout
          left={
            <React.Fragment>
              <Dropdown
                name="search_hotel_id"
                value={props.search.search_hotel_id}
                options={props.option_hotels}
                isClearable={false}
                isMulti={false}
                searchable={true}
                onChange={e => MonthlyReportAction.onEditMonthlySalesSearchCondition(e)}
                raised
              />
              <NormalButton onClick={e => MonthlyReportAction.onMonthlySalesMonthChanged(target_date.toISODate(), props.search.search_hotel_id)}>検索</NormalButton>
            </React.Fragment>
          }
        />

        <ListViewLayout>
          <DataTable
            style={{ minWidth: '1200px' }}
            headers={[
              <TH key="r_1">宿泊予約</TH>,
              <TH key="r_2">宿泊施設</TH>,
              <TH key="h_1" width="190px" isNumber>
                宿泊売上 <small>(決済手数料)</small>
              </TH>,
              <TH key="h_2" width="190px" isNumber>
                OTA手数料
              </TH>,
              <TH key="h_3" width="190px" isNumber>
                宿泊税 <small>(決済手数料)</small>
              </TH>
            ]}
            rows={props.heads.map((head, index) => (
              <TR key={index}>
                <TD>{stay(head.reservations)}</TD>
                <TD>{head.room_name}</TD>
                <TD isNumber>
                  <Money>{head.rsvn_sales}</Money>
                  <br />
                  <small>
                    (<Money>{head.rsvn_pay_comsn}</Money>)
                  </small>
                </TD>
                <TD isNumber>
                  <Money>{head.ota_comsn}</Money>
                </TD>
                <TD isNumber>
                  <Money>{accommodation_tax(head.reservations)}</Money>
                  <br />
                  <small>
                    (<Money>{head.accom_pay_comsn}</Money>)
                  </small>
                </TD>
              </TR>
            ))}
          />
        </ListViewLayout>
      </BaseLayout>
    </React.Fragment>
  )
}

function stay(reservations) {
  return (
    <React.Fragment>
      {reservations
        .map(r => (
          <React.Fragment>
            <Date showYear={false}>{r.check_in}</Date>→<Date showYear={false}>{r.check_out}</Date>　{r.name}
          </React.Fragment>
        ))
        .reduce((prev, curr) => [prev, <br />, curr])}
    </React.Fragment>
  )
}

function accommodation_tax(reservations) {
  if (!reservations || reservations.length === 0) {
    return 0
  }

  return reservations.map(r => (r.accommodation_tax ? paidAccommodationTax(r.accommodation_tax) : 0)).reduce((acc, cur) => acc + cur)
}

function paidAccommodationTax(accommodationTax) {
  return accommodationTax.tax_per_day * accommodationTax.number_of_guests * accommodationTax.number_of_nights
}
